module.exports = __webpack_public_path__ + "img/flavor9.4e6c8346.svg";